import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NavigationEnd, Router } from '@angular/router';

@Component({
    selector: 'app-toolbar',
    imports: [CommonModule, MatToolbarModule, MatIconModule],
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent {
  @Input() isSideNavOpend: boolean;
  @Output() toggleSideNav = new EventEmitter();
  title: string = '';
  constructor(private router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const url = event.url.split('/')[1];
        this.title = url.split('?')[0];
      }
    });
  }

  onToggleSideNavClick() {
    this.toggleSideNav.emit();
  }
}
